import React, { useState } from "react"
import { Button, ControlLabel, FormControl, FormGroup, InputGroup } from "react-bootstrap"
import Question from "./Question"


export default function AssessmentForm(props) {
  // PROPS
  const {
    assessmentInfo,
    editAssessment,
    addQuestion,
    editQuestion,
    removeQuestion,
    addOption,
    editOption,
    removeOption,
    formErrors
  } = props

  // STATE
  const [questionType, setQuestionType] = useState("")

  const handleAddQuestion = () => {
    addQuestion(questionType)
    setQuestionType("")
  }

  return (
    <div>
      <div style={{ paddingRight: "5px" }}>
        <h5>Required Score: (in percentages)</h5>
        <FormGroup validationState={
          formErrors[assessmentInfo.id] && formErrors[assessmentInfo.id]['required_score'] ? 'error' : null
        }>
          <FormControl
            type="number"
            min="1"
            max="100"
            value={ assessmentInfo.required_score }
            onChange={(e) => editAssessment("required_score", e.target.value) }
            placeholder="Enter a required score"
            style={{ width: "50%" }}
          />
          {
            formErrors[assessmentInfo.id] && formErrors[assessmentInfo.id]['required_score']
            ?
            <ControlLabel>{ formErrors[assessmentInfo.id]['required_score'] }</ControlLabel> : null
          }
        </FormGroup>
      </div>
      <div>
        <h5> </h5>
        <table className="assessment-form-question-list">
          <thead>
            <tr>
              <th style={{ width: "2%" }}></th>
              <th style={{ width: "50%" }}>Questions</th>
              <th className="option-col-heading">Options</th>
            </tr>
          </thead>
          <tbody>
            { assessmentInfo.questions.length ? assessmentInfo.questions.map((question, index) => {
              return (
                <Question
                  key={ index }
                  index={ index }
                  question={ question }
                  editQuestion={ editQuestion }
                  removeQuestion={ removeQuestion }
                  addOption={ addOption }
                  editOption={ editOption }
                  removeOption={ removeOption }
                  formErrors={ formErrors }
                />
              )
            })
              :
              <tr><td colSpan={2}>There are no questions for this assessment.</td></tr>
            }
          </tbody>
          <tfoot>
            <tr>
              <th></th>
              <th>Add a question</th>
            </tr>
            <tr>
              <td></td>
              <td style={{ paddingRight: "5px" }}>
                <InputGroup>
                  <FormControl
                    componentClass="select"
                    placeholder="select"
                    value={ questionType }
                    onChange={(e) => setQuestionType(e.target.value)}
                  >
                    <option disabled value="">Select a type...</option>
                    <option value="Radio">Single-select</option>
                    <option value="Multiselect">Multi-select</option>
                    <option value="Boolean">Boolean</option>
                  </FormControl>
                  <InputGroup.Button>
                    <Button disabled={ !questionType } onClick={ handleAddQuestion } bsStyle="primary">Add</Button>
                  </InputGroup.Button>
                </InputGroup>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTrainingManager/TrainingContainer/EditAssessmentModal/AssessmentForm.js